import React, { useContext } from "react"
import {
  Box,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Link,
  useTheme
} from "@carrotfertility/carotene-core"
import CloseIcon from "@mui/icons-material/Close"
import ReactMarkdown from "react-markdown"
import { RequiredItemModalsContext } from "./RequiredItemModalsContext"

type MarkdownAnchorProps = React.AnchorHTMLAttributes<HTMLAnchorElement> & { node?: unknown }

export function RequiredMenuItemDetailsModal(): JSX.Element {
  const theme = useTheme()
  const requiredItemModalsContext = useContext(RequiredItemModalsContext)

  if (!requiredItemModalsContext) {
    return <></>
  }

  const {
    detailsModalState: { isOpen, requiredNote },
    closeRequiredItemDetails
  } = requiredItemModalsContext

  return (
    <Dialog open={isOpen} onClose={closeRequiredItemDetails} aria-labelledby="required-menu-item-details-dialog-title">
      <DialogTitle
        id="required-menu-item-details-dialog-title"
        sx={{
          display: "flex",
          justifyContent: "flex-end",
          alignItems: "center",
          paddingRight: theme.spacing(theme.tokens.spacing.sm)
        }}
      >
        <Box
          component="button"
          type="button"
          aria-label="Close"
          onClick={closeRequiredItemDetails}
          sx={{
            marginLeft: "auto",
            padding: theme.spacing(theme.tokens.spacing.sm),
            cursor: "pointer",
            border: "none",
            background: "transparent",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CloseIcon fontSize="small" />
        </Box>
      </DialogTitle>
      <DialogContent sx={{ paddingTop: 0 }}>
        <DialogContentText component="span" sx={{ display: "block" }}>
          <ReactMarkdown
            components={{
              a: ({ href, children }: MarkdownAnchorProps) => (
                <Link href={href ?? "#"} target="_blank" rel="noopener noreferrer">
                  {children}
                </Link>
              )
            }}
          >
            {`Gregbot reminder: ${requiredNote}`}
          </ReactMarkdown>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  )
}
